import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-indigo-600 text-white shadow-md hover:bg-indigo-700 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 active:shadow-sm border-b-4 border-indigo-800 active:border-b-0',
    secondary: 'bg-white text-slate-700 shadow-sm border border-slate-200 hover:bg-slate-50 hover:text-slate-900 hover:shadow-md',
    success: 'bg-emerald-500 text-white shadow-md hover:bg-emerald-600 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 active:shadow-sm border-b-4 border-emerald-700 active:border-b-0',
    outline: 'bg-transparent border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-6 py-3.5 text-lg'
  };
  // If disabled, remove the 3D effect classes
  const variantClass = disabled ? variants[variant].replace(/hover:-translate-y-0.5|active:translate-y-0|active:border-b-0|border-b-4/g, '') : variants[variant];
  return <motion.button whileTap={!disabled ? {
    scale: 0.95
  } : {}} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} className={`
        ${baseStyles}
        ${variantClass}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled} {...props} data-id="element-1199">
      {children}
    </motion.button>;
}